import { User } from "../mutation-types";
import * as types from "../mutation-types";
import ResultMessage from "../../data/resultMessage";
import userApi from "../../api/user";

export default {
  namespaced: true,
  state: {
    // corp: {},
    userAccount: {
      customerNo: "",
      callVendroNo: "",
      saleVendroNo: "",
      corpNo: "",
      deptNo: "",
      name: "",
      role: "",
      state: "",
      corpName: "",
      isBillingPageVisible: null,
      accessToken: "",
      selectedVendors: []
    }
  },
  getters: {
    userAccount: function(state) {
      return state.userAccount;
    },
    accessToken: function(state) {
      return state.userAccount.accessToken;
    },
    isAuthentication: function(state) {
      return state.userAccount.accessToken != "";
    },
    isCallBillingPageVisible: function(state) {
      return state.userAccount.isBillingPageVisible;
    },
    userRole: function(state) {
      return state.userAccount.role;
    },
    routePath: function(state) {
      return state.userAccount.routePath;
    }
  },
  mutations: {
    // 사용자 계정 저장
    [User.SAVE_ACCOUNT](state, { payload }) {
      state.userAccount = payload;
    },
    [User.SAVE_VENDORS](state, { list }) {
      state.userAccount.selectedVendors = list;
    },
    [User.REMOVE_ACCOUNT](state) {
      state.userAccount = {
        customerNo: "",
        callVendroNo: "",
        saleVendroNo: "",
        corpNo: "",
        deptNo: "",
        name: "",
        role: "",
        state: "",
        corpName: "",
        accessToken: "",
        isBillingPageVisible: null,
        vendors: []
      };
    }
  },
  actions: {
    // async, await로.. IE에서 동작 안될시 promise로 변경 할것...
    login: async function(context, params) {
      // TODO : 로그인 처리후, mutation save_user_account commit 처리
      let resultMessage = new ResultMessage();
      await userApi
        .login(params)
        .then(response => {
          console.log(response);
          resultMessage.buildSuccessMessage(response);
          if (resultMessage.result != 0) {
            alert(resultMessage.title);
            return;
          }
          let payload = resultMessage.payload;
          context.commit(types.User.SAVE_ACCOUNT, { payload });
          return Promise.resolve(response);
        })
        .catch(error => {
          resultMessage.buildErrorMessage(error);
          return Promise.reject(error);
        });
    },
    saveSelectedVendors: function(context, list) {
      console.log(list);
      context.commit(User.SAVE_VENDORS, { list });
    },
    logout: function(context, payload) {
      context.commit(types.User.REMOVE_ACCOUNT);
    },
    bmwLogin: async function(context, payload) {
      let response = await userApi.loginForBMW(payload);
      let resultMessage = new ResultMessage();
      resultMessage.buildSuccessMessage(response);
      context.commit(types.User.SAVE_BMW_ACCOUNT, resultMessage.payload);
    },
    kiaLogin: async function(context, payload) {
      let response = await userApi.loginForKIA(payload);
      let resultMessage = new ResultMessage();
      resultMessage.buildSuccessMessage(response);
      context.commit(types.User.SAVE_ACCOUNT, resultMessage.payload);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/userAccount.js